import React from 'react';
import PropTypes from 'prop-types';
import './LoginHistoryPopup.css';
import { TEXT_NO_HISTORY } from 'utils/constanst';

const formatTimestamp = (timestamp) => {
  const date = new Date(Number(timestamp));
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);
  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
};

const LoginHistoryPopup = ({ isOpen, onClose, user, loginHistory }) => {
  if (!isOpen) return null;

  return (
    <div className="login-history-overlay" onClick={onClose}>
      <div className="login-history-popup" onClick={(e) => e.stopPropagation()}>
        <div className="login-history-header">
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="login-history-user-name">
          <h3>{user?.name}</h3>
        </div>
        <div className="login-history-content">
          {loginHistory && loginHistory.length > 0 ? (
            <div className="login-history-list">
              {loginHistory.filter(entry => entry.success).sort((a, b) => b.timestamp - a.timestamp).map((entry, index) => (
                <div key={index} className="login-history-item">
                  <span className="login-time">{formatTimestamp(entry.timestamp)}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-history">{TEXT_NO_HISTORY}</div>
          )}
        </div>
      </div>
    </div>
  );
};

LoginHistoryPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object,
  loginHistory: PropTypes.array
};

LoginHistoryPopup.defaultProps = {
  user: null,
  loginHistory: []
};

export default LoginHistoryPopup;